(function dynamicTextDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlPeriod', [])
        .directive('dynamicPeriod', function () {
            return {
                replace: true,
                restrict: 'E',
                templateUrl: '/app/directives/custom-control-period/custom-control-period-template.html',
                controller: [
                    '$scope', function ($scope) {
                        if ($scope.data && $scope.data.maskOptions && (typeof $scope.data.maskOptions === 'string')) {
                            $scope.data.maskOptions = $.parseJSON($scope.data.maskOptions);
                        }
                    }]
            };
        });

    angular.module('CustomControlPeriod')
        .directive('dynamicFilterPeriod', ['$translate', function () {
            return {
                templateUrl: '/app/directives/custom-control-period/custom-control-filter-period-template.html',
                replace: true,
                restrict: 'E',
                controller: [
                    '$scope', function ($scope) {
                        if ($scope.data && (!$scope.data.metadataSearchTypeFrom || !$scope.data.metadataSearchTypeTo)) {
                            $scope.data.metadataSearchTypeFrom = 'GreaterThanOrEqual';
                            $scope.data.metadataSearchTypeTo = 'LessThanOrEqual';
                        }

                        if ($scope.data && $scope.data.maskOptions && (typeof $scope.data.maskOptions === 'string')) {
                            $scope.data.maskOptions = $.parseJSON($scope.data.maskOptions);
                        }

                        $scope.changeSearchType = function () {
                            if ($scope.data.metadataValueFrom && !$scope.data.metadataValueTo) {
                                $scope.data.metadataSearchTypeFrom = 'Equal';
                            } else {
                                $scope.data.metadataSearchTypeFrom = 'GreaterThanOrEqual';
                            }
                        };
                    }
                ]
            };
        }]);
})();